/** Extract app_metadata from JWT access token payload (no verification — Supabase already validated it). */
export function getAppMetadata(token: string): Record<string, unknown> | null {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload?.app_metadata ?? null;
  } catch {
    return null;
  }
}
